import React from "react";

const Benefits: React.FC = () => {
  return (
    <div className="benefits">
      <div className="container">
        <div className="row no-gutters">
          <div className="col-md-6">
            <div className="benefits-resources">
              <h2>Learning resources designed for kids</h2>
              <p>
                Flexible, semi-structured learning resources designed to suit
                the short time frame that the kids have to spend at the cafe,
                delivered in fun and engaging formats.
              </p>
              <div className="quick-stats">
                <ul>
                  <li className="activities">
                    <div className="stat-value">100+</div>
                    <p>Activities</p>
                  </li>
                  <li className="weekdays">
                    <div className="stat-value">
                      10<sup>am</sup> - 5<sup>pm</sup>
                    </div>
                    <p>Monday - Friday</p>
                  </li>
                  <li className="saturday">
                    <div className="stat-value">
                      11<sup>am</sup> - 2<sup>pm</sup>
                    </div>
                    <p>Saturday</p>
                  </li>
                  {/* <li className="sunday"> */}
                  {/*   <div className="stat-value"> */}
                  {/*     2<sup>pm</sup> - 6<sup>pm</sup> */}
                  {/*   </div> */}
                  {/*   <p>Sunday</p> */}
                  {/* </li> */}
                </ul>
              </div>
            </div>
            <div className="benefits-avatar"></div>
          </div>
          <div className="col-md-6">
            <div className="benefits-activities">
              <h2>Amazing learning activities for kids</h2>
              <div className="activity-grid">
                <div>
                  <i className="fas fa-gamepad icon-orange"></i>
                  <p>Computer games</p>
                </div>
                <div>
                  <i className="fas fa-flask icon-green"></i>
                  <p>Digital Labs</p>
                </div>
                <div>
                  <i className="fas fa-code icon-amber"></i>
                  <p>Coding challenges</p>
                </div>
                <div>
                  <i className="fas fa-robot icon-cyan"></i>
                  <p>Robotic Kits</p>
                </div>
                <div>
                  <i className="fas fa-video icon-orange"></i>
                  <p>Short videos on emerging technologies</p>
                </div>
                <div>
                  <i className="fas fa-microchip icon-green"></i>
                  <p>Physical computing with Arduino</p>
                </div>
                <div>
                  <i className="fas fa-print icon-amber"></i>
                  <p>Prototyping with 3D printers</p>
                </div>
                <div>
                  <i className="fas fa-film icon-cyan"></i>
                  <p>Child friendly Sci-Fi animations/movies</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
